/**
 * Persist Google Ads admin format tab (Landscape / Square / Portrait).
 * Preference order: `?format=` in the URL → localStorage → index 0.
 */

export function readGoogleAdFormatTab(formats, storageKey) {
    if (typeof window === "undefined" || !Array.isArray(formats) || formats.length === 0) {
        return 0;
    }
    try {
        const fromUrl = new URLSearchParams(window.location.search).get("format");
        if (fromUrl) {
            const urlIndex = formats.findIndex((format) => format.id === fromUrl);
            if (urlIndex >= 0) return urlIndex;
        }
        const stored = window.localStorage.getItem(storageKey);
        if (stored) {
            const storedIndex = formats.findIndex((format) => format.id === stored);
            if (storedIndex >= 0) return storedIndex;
        }
    } catch {
        /* ignore */
    }
    return 0;
}

/** Save selected format to localStorage and keep `?format=` in sync with the address bar. */
export function persistGoogleAdFormatTab(formats, storageKey, tabIndex) {
    if (typeof window === "undefined" || !Array.isArray(formats)) return;
    const format = formats[tabIndex];
    if (!format?.id) return;
    try {
        window.localStorage.setItem(storageKey, format.id);
    } catch {
        /* ignore */
    }
    try {
        const url = new URL(window.location.href);
        url.searchParams.set("format", format.id);
        window.history.replaceState(null, "", `${url.pathname}${url.search}${url.hash}`);
    } catch {
        /* ignore */
    }
}
